import { baseApi } from 'core/api';

const state = () => ({
    _items: null,
    _pagination: null,
    _parameters: {
        page: 1,
        sortBy: 'seats',
        sortOrder: 'desc',
        search: null,
        length: 10,
    },
});

const getters = {
    organizations: (state) => {
        return state._items;
    },
    organizationsParameters: (state) => state._parameters,
    organizationsPagination: (state) => state._pagination,
};

const actions = {
    getKioskOrganizations(retry) {
        if (retry === true) {
            this._setOrganizationsRetryLoading();
        }

        return baseApi
            .get('core/kiosk/organizations', { params: this._parameters })
            .then((response) => {
                this._setOrganizationsLoaded(response.data);

                return response;
            })
            .catch(() => {
                this._setOrganizationsErrorLoading();
            });
    },

    getKioskAppByKey({ key, params }) {
        return baseApi.get(`core/kiosk/app/${key}`, { params }).then((response) => {
            return response.data;
        });
    },

    organizationsClearSearch() {
        this._setOrganizationsSearchCleared();

        this.getKioskOrganizations();
    },

    organizationsUpdateSort(sort) {
        this._setOrganizationsUpdateSort(sort);

        this.getKioskOrganizations();
    },

    organizationsUpdateSearch(search) {
        this._setOrganizationsUpdateSearch(search);

        this.getKioskOrganizations();
    },

    organizationsUpdatePage(page) {
        this._setOrganizationsUpdatePage(page);

        this.getKioskOrganizations();
    },

    organizationsUpdateLength(page) {
        this._setOrganizationsUpdateLength(page);

        this.getKioskOrganizations();
    },

    _setOrganizationsLoaded(data) {
        this._items = data.data;
        this._pagination = {
            current_page: data.current_page,
            from: data.from,
            last_page: data.last_page,
            per_page: data.per_page,
            to: data.to,
            total: data.total,
        };
    },

    _setOrganizationsRetryLoading() {
        this._items = null;
        this._pagination.total = 0;
    },

    _setOrganizationsErrorLoading() {
        this._items = false;
        this._pagination.total = 0;
    },

    _setOrganizationsUpdateSort(data) {
        this._parameters.sortBy = data.sortBy;
        this._parameters.sortOrder = data.sortOrder;
    },

    _setOrganizationsUpdateSearch(data) {
        this._parameters.search = data;
    },

    _setOrganizationsUpdatePage(data) {
        this._parameters.page = data;
    },

    _setOrganizationsUpdateLength(data) {
        this._parameters.length = data;
    },

    _setOrganizationsSearchCleared() {
        this._parameters.search = null;
    },
};

export default {
    state,
    getters,
    actions,
};
